import * as React from 'react'
import { Fragment } from 'react'
import { ReactTinyLink } from 'react-tiny-link'

// Components
import { Text } from '@metrisk/react_metrisk-components'
import { Form as WizardForm, Step, Field } from 'rewizard'
import FormField from './_FormField'
import FormStep from './_FormStep'

// Components
import { SubmissionOverlay } from '@components/SubmissionOverlay'

import './Form.scss'

const Form = (props: Form.IProps) => {
  const { config, content, data } = props

  if (data.error) {
    if (data.error.status == 'Bad Request' || data.error.status == 'unableToFind') {
      //"Bad Request" from submissionTracker
      //"unableToFind" from submissionAdditionalDetails
      return (
        <div>
          Something went wrong with processing your ID, this could be due to incorrect ID being entered. Please go back
          and try again or alternatively contact us.
        </div>
      )
    }
  }

  if (data.loading) return <div>Loading...</div>

  const notice = content.notice(config, data)
  const wizard = content.wizard(config, data)

  if (notice && notice.show)
    return (
      <Text tag={'h1'} type={'Gamma'}>
        {notice.msg}
      </Text>
    )

  const isPreview = window.location.href.includes('.preview.campaign') || window.location.href.includes('localhost')
  const qpl =
    !data.qualifiedPromoLinks || data.qualifiedPromoLinks.length == 0 ? null : (
      <div>
        <Text tag={'h2'} type={'Delta'}>
          Qualified Promos:
        </Text>
        <div>
          {data.qualifiedPromoLinks.map((pl: any, i: number) => {
            let linkUrl = isPreview && pl.previewUrl ? pl.previewUrl : pl.hostedUrl || pl.liveUrl || null
            return linkUrl ? <ReactTinyLink key={'pl' + i} url={linkUrl} /> : null
          })}
        </div>
      </div>
    )

  const renderFields = (step: any) => {
    return wizard.fields
      .filter(({ id }: any) => step.fieldIds.includes(id))
      .map(({ props, required, ...other }: any) => (
        <Field key={`field-${other.id}`} required={required} {...other}>
          {(field, fields) => <FormField fields={fields} required={required} {...props} {...field} />}
        </Field>
      ))
  }

  const renderSteps = (currentStep: string) => {
    return wizard.steps.map((step: any) => (
      <Step key={`step-${step.id}`} {...step}>
        {({ valid, submitPoint, prevId, prevStep, nextStep }: any) => (
          <FormStep
            id={step.id}
            currentStep={currentStep}
            valid={valid}
            submitting={data.submitting}
            submitPoint={submitPoint}
            hasPrevStep={!!prevId}
            prevStep={prevStep}
            nextStep={nextStep}
          >
            {step.heading && <h5>{step.heading}</h5>}
            {renderFields(step)}
          </FormStep>
        )}
      </Step>
    ))
  }

  return (
    <Fragment>
      <SubmissionOverlay data={data} />
      <WizardForm onSubmit={wizard.onSubmit} config={{ autoStep: false }}>
        {({ currentStep, handleSubmit }) => <form onSubmit={handleSubmit}>{renderSteps(currentStep)}</form>}
      </WizardForm>
      {qpl}
    </Fragment>
  )
}

export default Form
